import {Skeleton} from '@mantine/core';
import {forwardRef} from 'react';
import {MdArrowForward, MdArrowForwardIos} from 'react-icons/md';
import type {z} from 'zod';
import type {CompanySchema} from '../../../../core/entities/company/schema';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {CompanyCard} from '../Container/Presenter/CompanyCard';
import {COMPANY_LIST_LIMIT} from './constants';

type Props = {
  componentID: string;
  item: {
    id: number;
    name: string;
  };
  isLoading: boolean;
  companies: z.infer<typeof CompanySchema>[];
  industryPageUrl: string;
  inView: boolean;
};

export const CompaniesFramePresentation = forwardRef<HTMLDivElement, Props>(
  ({componentID, item, isLoading, companies, industryPageUrl, inView}, ref) => {
    return (
      <div
        id={componentID}
        ref={ref}
        className="w-full odd:bg-white py-16 pl-16 pc:pl-0"
      >
        <div className="mx-auto pc:w-[1200px] pc:h-[340px]">
          {inView && !isLoading && companies.length > 0 && (
            <CommonLink
              href={industryPageUrl}
              className="flex hover:opacity-70"
            >
              <h2 className="font-bold text-black text-xl">{item.name}</h2>
              <span className="p-4">
                <MdArrowForwardIos size={20} />
              </span>
            </CommonLink>
          )}

          <div className="flex py-8 gap-16 pc:gap-24 overflow-x-scroll">
            {inView &&
              !isLoading &&
              companies.length > 0 &&
              companies.map((company, index) => (
                <CompanyCard
                  key={`card-${item.id}-${index}`}
                  company={company}
                  width={300}
                  bgColorStyle="bg-transparent"
                />
              ))}
            {(!inView || isLoading) &&
              Array.from({length: 5}).map((_, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: order won't change
                <div key={index}>
                  <Skeleton height={250} width={300} />
                </div>
              ))}

            {companies.length === COMPANY_LIST_LIMIT && (
              <CommonLink
                href={industryPageUrl}
                className="shadow-card bg-white p-16 rounded-16 hover:opacity-70 flex items-center"
              >
                <div className="flex justify-center py-16">
                  <MdArrowForward size={40} />
                </div>
                <div>
                  <div className="text-md text-black text-center w-[200px]">
                    もっと見る
                  </div>
                </div>
              </CommonLink>
            )}
          </div>
        </div>
      </div>
    );
  },
);
